"use strict";
var QueueAction_1 = require('./QueueAction');
var QueueScheduler_1 = require('./QueueScheduler');
exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
//# sourceMappingURL=queue.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/scheduler/queue.js
 ** module id = 1392
 ** module chunks = 2
 **/